import { useEffect, useState } from "react";
import AddProfile from "./AddProfile";
import { useNavigate } from "react-router-dom";
import IProfile from "../../../models/profile";
import profileService from "../../../services/profile/ProfileService";
import AuthService from "../../../services/auth/AuthService";
import ITask, { ETaskType } from "../../../models/task";
import { Box, Paper } from "@mui/material";

const ProfileAddPage = () => {
    const navigate = useNavigate();
    const [isFormSending, setIsFormSending] = useState(false);

    const [profile, setProfile] = useState<IProfile>({
        description: "",
        name: "",
        companyId: 0,
        createDate: new Date(),
        id: 0,
        tasks: [],
        updateDate: new Date(),
    });

    const [ittasks, setiTtasks] = useState<ITask[]>([]);

    const onInputChange = <K extends keyof IProfile>(
        field: K,
        value: IProfile[K]
    ) => {
        setProfile((prevState) => ({
            ...prevState,
            [field]: value,
        }));
    };

    useEffect(() => {
        profileService.GetTasks().then(setiTtasks);
    }, []);
    const onCreateProfile = () => {
        setIsFormSending(true);

        const profileTasks: ITask[] = profile.tasks
            .map((id) => ({
                id,
            }))
            .map((task) => ({
                id: Number(task.id),
                name: "",
                description: "",
                type: ETaskType.Weekly,
                profiles: [],
            }));
        const iProfile: IProfile = {
            id: 0,
            name: profile.name,
            description: profile.description,
            companyId: AuthService.user?.companyId || 0,
            createDate: new Date(),
            tasks: profile.tasks,
            updateDate: new Date(),
        };
        profileService.PostProfile(iProfile).then(() => {
            setIsFormSending(false);
            navigate("..");
        });
    };

    return (
        <Box component={Paper} sx={{ width: "100%" }}>
            <AddProfile
                profile={profile}
                handleProfile={onCreateProfile}
                isCreation={true}
                isFormSending={isFormSending}
                onInputChange={onInputChange}
            />
        </Box>
    );
};

export default ProfileAddPage;
